import React from 'react';
import { useNavigate } from 'react-router-dom';

const PROJECTS = [
  {
    id: '2bhk-mulund-axis',
    name: '2BHK Apartment at Mulund by Axis Designs',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/36ce67256977595.Y3JvcCw1NzE5LDQ0NzQsNDk1LDA.jpg',
    behance: 'https://www.behance.net/gallery/256977595/2BHK-Apartment-at-Mulund-by-Axis-Designs-and-Concept',
    images: [
      '1c0dbb256977595.6acc7b1b448b5', '7525c9256977595.6acc7b1b49a64', '2d7815256977595.6acc7b1b47386',
      'ae4c08256977595.6acc7b1b46bee', '45c4b1256977595.6acc7b1b4863e', 'b9ffa4256977595.6acc7b1b46fba',
      'ba8a2f256977595.6acc7b1b46053', 'dea2d6256977595.6acc7b1b467bc', '2666df256977595.6acc7b1b44cee',
      '8639c0256977595.6acc7b1b47ea7', '3a34e4256977595.6acc7b1b463ff', 'd1d62b256977595.6acc7b1b4a51f',
      'c15152256977595.6acc7b1b47738', '8d198c256977595.6acc7b1b4825f', '1f5dce256977595.6acc7b1b48a10',
      '4c134c256977595.6acc7b1b45c3d', '009edf256977595.6acc7b1b454c0', '9cf1cb256977595.6acc7b1b4586c',
      '5de172256977595.6acc7b1b4a97d', 'e24985256977595.6acc7b1b491da', '7630a5256977595.6acc7b1b495d2',
      '1d868b256977595.6acc7b1b49f6f', '73835d256977595.6acc7b1b450d0', '00b572256977595.6acc7b1b48dfd',
      '30a200256977595.6acc7b1b47afd', '577d83256977595.6acc7b1b4ad68', '6a3101256977595.6acc7b1b4b5dd',
      '0aa140256977595.6acc7b1b4c9ad', 'e913e4256977595.6acc7b1b4d5c3', '4778c4256977595.6acc7b1b4b9c7',
      '1e0bc3256977595.6acc7b1b4b135', '6ca20b256977595.6acc7b1b4eac1', '419ec2256977595.6acc7b1b4bd8d',
      'af009a256977595.6acc7b1b4cd6b', 'ee60bd256977595.6acc7b1b50463', '8e43dc256977595.6acc7b1b4d162',
      '51809d256977595.6acc7b1b4c562', '5fe0e6256977595.6acc7b1b4c182', '3a7159256977595.6acc7b1b4de62',
      'f3e760256977595.6acc7b1b4d9e1', '0d0c45256977595.6acc7b1b52111', 'ea2dc5256977595.6acc7b1b4f61f',
      '241c4f256977595.6acc7b1b4e509', '60a68d256977595.6acc7b1b4fbc4', '606fb9256977595.6acc7b1b4f06a',
      'ea1523256977595.6acc7b1b4ffdd', 'f5112c256977595.6acc7b1b511e8', 'd975ee256977595.6acc7b1b51ab8',
      'bdb958256977595.6acc7b1b508c5', '936b02256977595.6acc7b1b50db9', '00e983256977595.6acc7b1b5165a',
      'ed4786256977595.6acc7b1b52a0a', '7ca7ef256977595.6acc7b1b52604',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'perfect-stones',
    name: 'Perfect Stones by Rajesh Atha Architects',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/83893b256976501.Y3JvcCw1NzE5LDQ0NzQsNDk1LDA.jpg',
    behance: 'https://www.behance.net/gallery/256976501/Perfect-Stones-By-Rajesh-Atha-Architects',
    images: [
      'e46c42256976501.6acc73439efd9', 'ebbe6e256976501.6acc7343a25e2', 'd43433256976501.6acc7343a0237',
      'b3dc44256976501.6acc73439f8d5', '03f267256976501.6acc7343a1d28', '4d734f256976501.6acc7343a4246',
      '61f739256976501.6acc7343a6c9d', '5c48cf256976501.6acc7343a6498', '6012cb256976501.6acc7343a4b20',
      '529a7e256976501.6acc7343a3005', 'a80e3e256976501.6acc7343a5bd5', '47a50a256976501.6acc7343a0a6b',
      'e7d13e256976501.6acc7343a13d1', '654630256976501.6acc7343a39ca', 'aebe87256976501.6acc7343a538c',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'jbcn-school',
    name: 'JBCN International School by Tangents Design Cell',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/c52cd4256977253.Y3JvcCw1NzE5LDQ0NzQsNDk1LDA.jpg',
    behance: 'https://www.behance.net/gallery/256977253/JBCN-International-School-by-Tangents-Design-Cell',
    images: [
      '476102256977253.6acc78a0ac6de', '7e06b9256977253.6acc78a0b0db6', 'e5b092256977253.6acc78a0b14df',
      '3b5c07256977253.6acc78a0ad262', 'd151fe256977253.6acc78a0acab8', 'fad4bf256977253.6acc78a0ae865',
      '01b801256977253.6acc78a0af3d7', 'fe0b27256977253.6acc78a0afb2e', '7f6714256977253.6acc78a0aef93',
      'f3f079256977253.6acc78a0ace9c', '13cc29256977253.6acc78a0b1150', 'fa62c2256977253.6acc78a0b1883',
      'b34228256977253.6acc78a0ad966', 'dfcef0256977253.6acc78a0af7a1', '290a8e256977253.6acc78a0ad5fd',
      '25ca9d256977253.6acc78a0b0a10', 'bc5f51256977253.6acc78a0b0666', 'e40e2b256977253.6acc78a0aebeb',
      'ae7adc256977253.6acc78a0ae483', 'c75061256977253.6acc78a0afec3', '7978a7256977253.6acc78a0b02c0',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: '3bhk-wadala-kea',
    name: '3BHK Wadala Apartment by KEA Design Labs',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/d97320256976797.Y3JvcCw0NDc0LDM0OTksMCwxNjM4.jpg',
    behance: 'https://www.behance.net/gallery/256976797/3BHK-Wadala-Apartment-by-KEA-Design-Labs',
    images: [
      '9a1a66256976797.6acc759419708', 'c84325256976797.6acc75941d458', '115756256976797.6acc759420b6d',
      '05355d256976797.6acc75941dd7c', '8a1dce256976797.6acc75941d8d4', '58e3da256976797.6acc759420195',
      '205e6c256976797.6acc75941e22d', '40e3e5256976797.6acc75941efce', '03592b256976797.6acc75941bf6b',
      'e6484e256976797.6acc75941cf7d', 'b2b4e7256976797.6acc75941e6b3', 'd5720d256976797.6acc75941b1e5',
      '96e261256976797.6acc75941f42f', '636096256976797.6acc75941a373', '3ba5ad256976797.6acc759421033',
      '1e58c0256976797.6acc75941eb32', '8efd24256976797.6acc75941c507', 'd05210256976797.6acc75941ada0',
      '50b03e256976797.6acc75941b7b9', 'a87d63256976797.6acc759420696', 'abe3e7256976797.6acc75941f8a9',
      '1720cc256976797.6acc75941a8b5', '6ce2af256976797.6acc759419d42', '7019ac256976797.6acc75941fd2b',
      'e345e8256976797.6acc75941ca8d', 'df52d3256976797.6acc7594219e5', '3e08d2256976797.6acc759421549',
      'b0e03d256976797.6acc759421e28', '5707ce256976797.6acc7594226fb', '4c2a74256976797.6acc7594246d3',
      'c32661256976797.6acc7594234ac', '34376d256976797.6acc759424f9a', '4bf8d0256976797.6acc75942541f',
      '0f80a6256976797.6acc759422258', '06f80a256976797.6acc759423915', 'a54a22256976797.6acc759423dc7',
      '6f2914256976797.6acc75942425b', '2021dd256976797.6acc759423031', '96c3fa256976797.6acc759424b05',
      'b4910e256976797.6acc75942656b', '3ab07f256976797.6acc759422ba9', 'e461c5256976797.6acc759425875',
      'e63c19256976797.6acc759425ce0', 'e12378256976797.6acc7594269fa', 'f04411256976797.6acc75942613a',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'sobo-kaizaad',
    name: 'SOBO Apartment by Kaizaad Mehta Architects',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/5fccb6256977723.Y3JvcCw0NDc0LDM0OTksMCwxNDk1.jpg',
    behance: 'https://www.behance.net/gallery/256977723/SOBO-Apartment-by-Kaizaad-Mehta-Architects',
    images: [
      '8f0d5a256977723.6acc7c1b2be26', '65410f256977723.6acc7c1b2c6ef', '625ae5256977723.6acc7c1b30bb3',
      '2ae4b7256977723.6acc7c1b2dfd5', 'ab5e46256977723.6acc7c1b31c27', 'e6167a256977723.6acc7c1b2f0bd',
      'b378c0256977723.6acc7c1b2d72e', '0a9c1d256977723.6acc7c1b2ced3', '3a523b256977723.6acc7c1b2f9f7',
      'c6e129256977723.6acc7c1b302e0', 'e72b72256977723.6acc7c1b2e782', 'a68c4b256977723.6acc7c1b3140f',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: '2bhk-ghansoli',
    name: '2BHK Apartment at Ghansoli by Ar. Prathamesh Salvi',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/bab730256977065.Y3JvcCw0NDc0LDM0OTksMCwyMjAz.jpg',
    behance: 'https://www.behance.net/gallery/256977065/2BHK-Apartment-at-Ghansoli-by-Ar-Prathamesh-Salvi',
    images: [
      'fb7c3f256977065.6acc7778eb276', 'cd3ded256977065.6acc7778e7bba', 'd9bd88256977065.6acc7778f0c29',
      '594055256977065.6acc7778ec0c6', '48d3d1256977065.6acc7778ec92c', '4d8915256977065.6acc7778ef653',
      'b46f57256977065.6acc7778f1b0a', '5ef9fd256977065.6acc7778f0500', '26a5eb256977065.6acc7778ee5bd',
      'bfd083256977065.6acc7778f13c4', '457e0c256977065.6acc7778ed07e', 'f337c1256977065.6acc7778ed782',
      '1eb282256977065.6acc7778eaa65', 'ae2cb5256977065.6acc7778eb989', 'a61856256977065.6acc7778efdf5',
      '80a827256977065.6acc7778e9b45', '378695256977065.6acc7778edec8', '37c92f256977065.6acc7778eef36',
      'cb389c256977065.6acc7778e843b', '1a2f59256977065.6acc7778e9384', '57d511256977065.6acc7778f21ef',
      'dcb71d256977065.6acc7778ea2a8', '1acaaa256977065.6acc7778e8bc6',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'jolly-maker-office',
    name: 'Jolly Maker Office by Thinking Hand Atelier',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/a7d8e3256976171.Y3JvcCw1NzE5LDQ0NzQsNDk1LDA.jpg',
    behance: 'https://www.behance.net/gallery/256976171/Jolly-Maker-Office-by-Thinking-Hand-Atelier',
    images: [
      'da88a1256976171.6acc70e3ef3a1', 'd5b25a256976171.6acc70e3f0f1b', '2694a4256976171.6acc70e3f31f1',
      '12c305256976171.6acc70e40126f', 'e099fc256976171.6acc70e3f4237', 'de4095256976171.6acc70e404bc4',
      'dbff4a256976171.6acc70e4008ca', '42f9c3256976171.6acc70e3f0608', '5d8eda256976171.6acc70e3f3a7e',
      '352421256976171.6acc70e403062', 'd7d966256976171.6acc70e40216d', '156ab8256976171.6acc70e3efd06',
      'e5d4e9256976171.6acc70e3f2954', 'e5b77f256976171.6acc70e3f2094', '69bec0256976171.6acc70e404380',
      '944e44256976171.6acc70e4039ed', '4db2cc256976171.6acc70e3f17f0',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'mumbai-imporio',
    name: 'Mumbai Imporio by Muzie Architects',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/a8fef0256977871.Y3JvcCw0ODYzLDM4MDQsMTEzMSww.jpg',
    behance: 'https://www.behance.net/gallery/256977871/Mumbai-Imporio-by-Muzie-Architects',
    images: [
      'daafa0256977871.6acc7d0fb560f', '1e5575256977871.6acc7d0fb82ea', '642505256977871.6acc7d0fb78ce',
      'c1b1c7256977871.6acc7d0fb929a', '41ecbd256977871.6acc7d0fb8a13', '2bc6a4256977871.6acc7d0fb4de5',
      '4fb002256977871.6acc7d0fb6fc2', '4b109c256977871.6acc7d0fb6697', '6fa384256977871.6acc7d0fb5d8f',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'shubham-motiwala',
    name: 'Shubham Motiwala Jewellery Shop by KEA Design Labs',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/808_webp/e427d5256975567.Y3JvcCw1NDY0LDQyNzMsMCwxOTYx.jpg',
    behance: 'https://www.behance.net/gallery/256975567/Shubham-Motiwala-Jwellery-shop-by-KEA-Design-Labs',
    images: [
      '2af161256975567.6acc6c8b2aa19', '4b2711256975567.6acc6c8b3216e', '10a729256975567.6acc6c8b2f300',
      'de227b256975567.6acc6c8b2b25e', '400529256975567.6acc6c8b30257', 'fe254f256975567.6acc6c8b309cb',
      '2e75b1256975567.6acc6c8b2d1ac', '21f4e9256975567.6acc6c8b2daed', 'b20085256975567.6acc6c8b2c77e',
      'd35149256975567.6acc6c8b2b962', '3ea2b5256975567.6acc6c8b31101', '6dc16a256975567.6acc6c8b2fb1a',
      'b56833256975567.6acc6c8b2c059', 'a62be6256975567.6acc6c8b2e9c7', '60e509256975567.6acc6c8b3182e',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'leela-raj',
    name: 'Leela Raj',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/38fd1d247137919.Y3JvcCw1NzE5LDQ0NzQsNDk1LDA.jpg',
    behance: 'https://www.behance.net/gallery/247137919/LEELA-RAJ',
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/ea9260e627e5d59a_SVA_2852-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/c5be16146d28a18d_SVA_2748-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/9e79529d8e81ce94_SVA_2847-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/2113e2dd292b9d29_SVA_2842-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/d5470604720feb5b_SVA_2753-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/08f54c26f99026ba_SVA_2743-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/67b83413505d54a2_SVA_2733-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/ebf0995a1b83f19a_SVA_2708-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/667167f27e9654ba_SVA_2469-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/49a6336898edaf08_SVA_2409-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/ca2eb1c8c2952f06_SVA_2419-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/28fab17568dd1af9_SVA_2429-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/29ba9b52d3f2384b_SVA_2454-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/9b801c3e070d1fae_SVA_2632-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/a7e0194c39fb7b57_SVA_2537-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/471b6c6bce6e7092_SVA_2577-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/08a61c21d5154f52_SVA_2552-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/dcc21186f3c36da4_SVA_2567-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/98b6fd5690b59fa0_SVA_2592-HDR-Edit.webp',
    ],
  },
  {
    id: 'burhani-manzil',
    name: 'Burhani Manzil',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/9d8f1a247137379.Y3JvcCw0NDY1LDM0OTIsMCwyMTU1.jpg',
    behance: 'https://www.behance.net/gallery/247137379/BURHANI-MANZIL',
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/5f7445f0b881c1c5_SVA_2114-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/327dc4adf040dcaa_SVA_2036-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/379ebcac8fae7304_SVA_2057-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/09c09ce4bfd07026_SVA_2109-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/a22b96fdb8dee812_SVA_2104-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/6afce7529a60e7c6_SVA_2099-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/6096a10e66cc7aa9_SVA_2119-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/7e2a536898f0e9f7_SVA_2129-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/85fbee7b25d85008_SVA_2134-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/f20614e00d9591ab_SVA_2124-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/3b8f79bcebab6608_SVA_1951-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/c1836e398cd78ea2_SVA_1956-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/1b5da9d9a8c3cd57_SVA_1991-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/b7baf172b7591c02_SVA_2001-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/5136fa226e90fb69_SVA_2006-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/efa8f9a7acc323c9_SVA_1890-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/c2fef774160aaa67_SVA_1900-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/8a8c69c0840097a8_SVA_1916-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/08ceb2ebc21b2d6d_SVA_1926-HDR-Edit.webp',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_varad-founder-hub/artifacts/05bf598d69e450d8_SVA_1936-HDR-Edit.webp',
    ],
  },
  {
    id: 'aida-haus-of-stellar',
    name: 'Aida by Haus of Stellar',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/e6b45e243132711.Y3JvcCwyODcxLDIyNDYsMCwxMTE2.jpg',
    behance: 'https://www.behance.net/gallery/243132711/AIDA-by-Haus-of-Stellar',
    images: [
      'ad5867243132711.697b2e489e9c2', 'b6438d243132711.697b2e48a656d', '6751ab243132711.697b2e48a3d54',
      '4f2286243132711.697b2e48a7b60', '1d8fcc243132711.697b2e489f573', 'cdcf52243132711.697b2e48a1a5c',
      '01fd42243132711.697b2e48a3625', '8f7be2243132711.697b2e48a8997', '681e98243132711.697b2e48a83be',
      '713629243132711.697b2e48a1462', '84d396243132711.697b2e489fd1b', 'd90d43243132711.697b2e48a6cfa',
      'bf90d6243132711.697b2e48a1f66', 'f3e3d3243132711.697b2e48a2649', 'abe25a243132711.697b2e48a4379',
      'a09251243132711.697b2e48a0f4b', '7345d9243132711.697b2e48a746d', '172fe9243132711.697b2e48a50a1',
      '364583243132711.697b2e48a4973', '01eb8a243132711.697b2e48a914f', '3a1874243132711.697b2e48a0426',
      'd5d6ec243132711.697b2e48a2b32', '5b034c243132711.697b2e48a0a04', 'ee854e243132711.697b2e48a30ef',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: '3bhk-muzei',
    name: '3BHK Apartment by Muzei Architect',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/9901e9235899605.Y3JvcCw1NzE5LDQ0NzQsNDk1LDA.jpg',
    behance: 'https://www.behance.net/gallery/235899605/3BHK-APARTMENT-IN-MUMBAI-DESIGNED-BY-MUZEI-ARCHITECT',
    images: [
      '8fdab0235899605.68e0a4d3e110b', '84f5c0235899605.68e0a4d3dfadd', '72e7df235899605.68e0a4d3e26ca',
      '719d6e235899605.68e0a4d3de79c', 'c965a0235899605.68e0a4d3e3746', 'feeecf235899605.68e0a4d3e48da',
      '54cba5235899605.68e0a4d3e1ee9', 'd5044b235899605.68e0a4d3e08be', 'fb42b3235899605.68e0a4d3e3fe6',
      '20df2c235899605.68e0a4d3df494', '790154235899605.68e0a4d3dee5e', 'f5fa2e235899605.68e0a4d3e0217',
      '696af1235899605.68e0a4d3e18ee', '5976dc235899605.68e0a4d3e3056',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: '3bhk-dot-dgw',
    name: '3BHK Apartment by Dot DGW',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/a5d87d235899305.Y3JvcCw0NDc0LDM0OTksMCwxMDQw.jpg',
    behance: 'https://www.behance.net/gallery/235899305/3BHK-APARTMENT-INTERIOR-DESIGNED-BY-DOT-DGW',
    images: [
      '8d8408235899305.68e0a23a2eb85', 'c04fb3235899305.68e0a23a1555f', '4abd4d235899305.68e0a23a15ea7',
      '938151235899305.68e0a23a168d4', 'ad0085235899305.68e0a23a26381', '3b8e5c235899305.68e0a23a17074',
      '66abe2235899305.68e0a23a17a52', '6751e7235899305.68e0a23a26b8c', 'd4ef2a235899305.68e0a23a2ce10',
      '84d5da235899305.68e0a23a18203', 'df22c1235899305.68e0a23a25b25', '8f67ab235899305.68e0a23a2d883',
      '94c876235899305.68e0a23a2f392', '74c38f235899305.68e0a23a2e320', '10b5e2235899305.68e0a23a2fb46',
      '69bb4d235899305.68e0a23a3058f', '379ae6235899305.68e0a23a30d29',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: '4bhk-kea',
    name: '4BHK Apartment by Kea Design Labs',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/04f6bc235630885.Y3JvcCw1NzE5LDQ0NzQsMTg0LDA.jpg',
    behance: 'https://www.behance.net/gallery/235630885/4BHK-APARTMENT-IN-MUMBAI-DESIGNED-BY-KEA-DESIGN-LABS',
    images: [
      '0be035235630885.68db69d401ebb', '7da0b4235630885.68db69d4029f8', '08312b235630885.68db69d406175',
      '5874cc235630885.68db69d408121', '836854235630885.68db69d40e57a', '9ce181235630885.68db69d40582f',
      '0d080c235630885.68db69d403287', '63b82c235630885.68db69d408bec', 'aad12f235630885.68db69d403ae0',
      'aeee37235630885.68db69d40d16d', '1a2172235630885.68db69d40ab46', 'daf5bd235630885.68db69d40b36c',
      '253706235630885.68db69d40c5ab', 'bea2c7235630885.68db69d40a300', 'f494b2235630885.68db69d40da5c',
      '590de9235630885.68db69d4045e9', 'f47911235630885.68db69d404e7f', 'ffa402235630885.68db69d4077e6',
      'dca457235630885.68db69d406c47', 'fa1982235630885.68db69d409705', '58e2c3235630885.68db69d40bc5e',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: '4bhk-karjat',
    name: '4BHK Villa at Karjat by TheBrickStory',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/9fbd8b235631631.Y3JvcCw1NzE5LDQ0NzQsNDk1LDA.jpg',
    behance: 'https://www.behance.net/gallery/235631631/4BHK-VILLA-AT-KARJAT-DESIGNED-BY-THEBRICKSTORY',
    images: [
      'a1aa0f235631631.68db6e9ba4a57', 'e59592235631631.68db6e9ba1c21', 'b60678235631631.68db6e9b9f9ad',
      'dcf59f235631631.68db6e9ba2134', 'e0bd68235631631.68db6e9ba34c8', '144da8235631631.68db6e9ba3ab8',
      '64428b235631631.68db6e9ba0e16', '6a78af235631631.68db6e9ba5237', '8f2cf4235631631.68db6e9ba263c',
      '6df431235631631.68db6e9ba3f7f', 'b42d56235631631.68db6e9b9ec9c', 'a631de235631631.68db6e9ba442e',
      '14d142235631631.68db6e9b9e6ec', 'f34fb9235631631.68db6e9ba0185', '9d715f235631631.68db6e9ba177d',
      '14eccf235631631.68db6e9ba12ab', '7d4a0d235631631.68db6e9ba5a02', '0fe10b235631631.68db6e9ba2dd6',
      'cee4d0235631631.68db6e9ba095b', '3c156e235631631.68db6e9b9f4a5',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: '4bhk-rks-may',
    name: '4BHK Apartment at RKS by May Projects',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/c1d1f9217091217.Y3JvcCw1NzA5LDQ0NjYsNDk0LDA.jpg',
    behance: 'https://www.behance.net/gallery/217091217/4BHK-APRTMENT-AT-RKS-BY-MAY-PROJECTS-INDIA',
    images: [
      '16b7a7217091217.678a963e95436', 'c2fbc1217091217.678a963e94eff', '8ace74217091217.678a963f4c5c5',
      '2cbd10217091217.678a963f4cb0b', '7483a2217091217.678a964018d82', '2ab767217091217.678a9640195f0',
      '28ddd8217091217.678a9640b7089', '462929217091217.678a9640b786f', '626197217091217.678a9641987dd',
      '7e2afd217091217.678a96419964e', '98453e217091217.678a964199012', 'd45fe3217091217.678a964273e23',
      'fdbb6e217091217.678a964273660', 'a09d3e217091217.678a964321e9a', 'f19d09217091217.678a964321462',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'rks-studio-aiza',
    name: 'RKS by Studio Aiza',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/5f3684217185765.Y3JvcCw0NDY1LDM0OTIsMCwxMjI2.jpg',
    behance: 'https://www.behance.net/gallery/217185765/RKS-BY-STUDIO-AIZA',
    images: [
      '8a2c5d217185765.678cbe9094930', 'cd8186217185765.678cbe9094efd', '8b2cdc217185765.678cbe9094405',
      'c004e9217185765.678cbe9093e46',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'nivaant-farm',
    name: 'Nivaant Farm by May Project India',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/6580dd217187485.Y3JvcCwyODk5LDIyNjgsNTY3LDA.jpg',
    behance: 'https://www.behance.net/gallery/217187485/NIVAANT-FARM-BY-MAY-PROJECT-INDIA',
    images: [
      '086e17217187485.678cc92c53237', '5e29d7217187485.678cc92c504da', '980783217187485.678cc92c519c2',
      '7ed272217187485.678cc92c50cf8', '2e20b0217187485.678cc92c51e5e', '396ffd217187485.678cc92c522f6',
      '0deffa217187485.678cc92c5372a', 'b667de217187485.678cc92c52a79', '8fef7a217187485.678cc92c51226',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'nhsrcl-dev',
    name: 'NHSRCL by Dev Associates',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/59d8f6217186007.Y3JvcCw1NTk3LDQzNzgsNDg0LDA.jpg',
    behance: 'https://www.behance.net/gallery/217186007/NHSRCL-BY-DEV-ASSOCIATES',
    images: [
      '0000d7217186007.678cc09175e73', '33720c217186007.678cc0917661a', '387d39217186007.678cc09175111',
      '7b862b217186007.678cc0917587c', '0816d4217186007.678cc0917483c', 'd2e32a217186007.678cc09173f7b',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
  {
    id: 'neotra-sarayan',
    name: 'Neotra by Sarayan',
    image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/05bc89217092729.Y3JvcCw1NzA5LDQ0NjYsNDk0LDA.jpg',
    behance: 'https://www.behance.net/gallery/217092729/NEOTRA-BY-SARAYAN',
    images: [
      '519680217092729.678a9b327ca58', 'f12db8217092729.678a9b327cf60', '415e8d217092729.678a9b33858ab',
      'ff8a3e217092729.678a9b3384fb5', '61cf43217092729.678a9b3473720', '47003b217092729.678a9b3472df3',
    ].map((k) => `https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/${k}.jpg`),
  },
];

export { PROJECTS };

const Gallery = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="gallery-page">
      <div className="px-4 sm:px-8 md:px-12 pt-8 pb-16">
        <div className="project-grid">
          {PROJECTS.map((project) => (
            <div
              key={project.id}
              className="project-tile"
              onClick={() => navigate(`/project/${project.id}`)}
              data-testid={`project-tile-${project.id}`}
            >
              <img
                src={project.image}
                alt={project.name}
                loading="lazy"
              />
              <div className="tile-label">{project.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
